import React from "react"

export default()=><div>
    about
</div>